export const ZERO_PRICE_VALUE: number = 9999999;
